module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9UuaKi/tc-custom/9781617452215.jpg?1717877895248",
      "alt": "This image is the cover for the book Quilter's Precut Companion"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Quilter's Precut Companion\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Everything you need to know about making quilts with precuts Master precuts with this compete and indispensable guide to working with Charm Packs, Layer Cakes, Jelly Rolls, Turnovers, and more! Sew 25 traditional blocks from squares, half-square triangles, and precut strips with timesaving tips and tricks from the one and only Missouri Star Quilt Company. You’ll cover all the basics, including precut options, standard quilt sizes and needle types. Plus, finish your quilt like a pro with yardage and cutting info for borders, backings, and bindings! Easy-to-use charts, tables, and illustrations are at your fingertips in this handy, spiral-bound guide that’s easy to take with you. • All-in-one guide to precuts in a portable, spiral-bound reference that’s easy to take with you • Make 25 traditional quilt blocks from precut squares, strips, and triangles, with bonus info on easy half-square triangles • Time-saving tips and tricks plus easy-to-use charts with basic quilt sizes, and yardage for borders, backings, and bindings")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jenny Doan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0